import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useKiCodeAccess } from 'ts-components/KiCode/useKiCodeAccess';

export const useBusinessAppPermissions = () => {
  const access = useSelector(
    (s: any) =>
      s.authentication.access?.sections?.marketplace_section
        ?.business_app_developer
  );

  const canViewBusinessApps = Boolean(access?.view);
  const canPublishBusinessApps = Boolean(access?.remove);
  const canEditWithKiCode = useKiCodeAccess();
  return useMemo(
    () => ({ canViewBusinessApps, canPublishBusinessApps, canEditWithKiCode }),
    [canViewBusinessApps, canPublishBusinessApps, canEditWithKiCode]
  );
};
